import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {changeGroupField} from "../../../../../store/actions/groupFields";
import ParametersNotice from "../../Parameters/ParametersNotice";
import CustomTableNotice from '../../CustomTableNotice';

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	getField(name) {
		return [
			{
				name:   name,
				label:  name,
				fields: [
					getFieldFactory().getSourceField(), getFieldFactory().getValueInputType('input', 'Value'), getFieldFactory().getParametersField(), {
						id:           'compare',
						inputType:    'select',
						source:       'compareTypesCustomTable',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Compare',
						defaultValue: 'Select a comparison type',
						dynamic:      false
					},
					getFieldFactory().getDynamicField()
				],
			}
		];
	}

	render() {

		const {addSubField, group, customTables, changeGroupField} = this.props;

		return (<FieldGroupContext.Consumer>

				{({endpointId, endpoint, currentItem, action}) => (

					<React.Fragment>

						{ endpoint[action][currentItem].tableSelection[0].fields[0].value ?
						<React.Fragment>

						<h3>Default Fields ({endpoint[action][currentItem].defaultFields.length})</h3>

						<p>Use this section for refining your query by adding filters for the table columns.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<label>Relation Type:</label>
						<select className="restroutes-select-small" value={endpoint.displayCustomTable[currentItem].mainRelationType} onChange={e => changeGroupField(endpointId, 'displayCustomTable', currentItem, 'mainRelationType', e.target.value)}>
							<option value="AND">AND</option>
							<option value="OR">OR</option>
						</select>

						<br />
						<br />

						<label>Select a column:</label>
						<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
							{customTables && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']] && customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].map((el, index) => <option key={index}
																																																							   value={el}>{el}</option>)}
						</select>

						<button
							onClick={() => addSubField(endpointId, this.getField(customTables[endpoint[action][0]['tableSelection'][0].fields[0]['value']].filter(el => el === this.state.selectedFilterToAdd)), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
						>
							Add a filter
						</button>

						<FieldGroups group={group}/>
						</React.Fragment> : <CustomTableNotice/> }

					</React.Fragment>)}

			</FieldGroupContext.Consumer>);
	}
}

const mapStateToProps = (state) => (state);

const mapDispatchToProps = dispatch => ({
	addSubField:      (endpointId, field, currentItem, group, parentGroup) => dispatch(addSubField(endpointId, field, currentItem, group, parentGroup)),
	changeGroupField: (endpointId, group, index, field, value) => dispatch(changeGroupField(endpointId, group, index, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultFieldsFilter);
